const GlobalFilters = {
  install (Vue) {
    Vue.filter('TO_TEL', (v) => {
      if (v) {
        return (v.length === 10)
          ? v.replace(/(\d{2})(\d{4})(.*)/g, '($1) $2-$3') // Telefones fixos
          : v.replace(/(\d{2})(\d{5})(.*)/g, '($1) $2-$3') // Telefones celulares
      }
    })
    Vue.filter('TO_UPPER', (v) => {
      if (v) {
        return v.toUpperCase()
      }
    })
    Vue.filter('TO_LOWER', (v) => {
      if (v) {
        return v.toLowerCase()
      }
    })
    Vue.filter('TO_SENTENCE', (v) => {
      if (v) {
        return v[0].toUpperCase() + v.split(v[0])[1].toLowerCase()
      }
    })
    Vue.filter('TO_CNPJ', (v) => {
      if (v) {
        return v.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, '$1.$2.$3/$4-$5')
      }
    })

    Vue.filter('TO_CPF', (value) => {
      if (value) {
        return value.replace(/(\d{3})(\d{3})(\d{3})(\d*)/g, '$1.$2.$3-$4')
      }
    })

    Vue.filter('TO_CEP', (v) => {
      if (v) {
        return v.replace(/(\d{5})(\d{3})(.*)/g, '$1-$2')
      }
    })
    Vue.filter('TO_DELIVERY', (v) => {
      if (v) {
        var options = { month: 'short', day: 'numeric' }
        let date = new Date(v)
        return date.toLocaleDateString('pt-BR', options)
      }
    })
    Vue.filter('TO_MONEY', (v) => {
      let str = `${v}`
      if (str.indexOf('.') > -1) {
        return 'R$ ' + str.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      } else {
        return 'R$ ' + str.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      }
    })
    Vue.filter('TO_BRL', (cents) => {
      if (!Number.isFinite(cents)) {
        cents = cents / 100
      }
      if (cents < 0) {
        cents = cents * -1
      }
      cents = cents.toFixed(2)
      cents = cents.replace(/\D/g, ',')
      if (cents.split(',')[0].length > 3) {
        cents = cents.split(',')
        let hundreds = parseInt(cents[0]) / 1000
        hundreds = hundreds.toFixed(3)
        hundreds = hundreds.replace(/\D/g, '.')
        cents = hundreds + ',' + cents[1]
      }
      return cents
    })
    Vue.filter('TO_DATE', (v) => {
      if (v) {
        var options = { day: 'numeric', month: 'numeric', year: 'numeric' }
        let date = new Date(v)
        return date.toLocaleDateString('pt-BR', options)
      } else {
        return '--'
      }
    })
    Vue.filter('TO_ROLES', (v) => {
      if (v) {
        let str = ''
        let i = 1
        for (let role of v) {
          str = str + role.replace(/_/g, ' ').replace('ROLE', '') + (v.length !== i ? ', ' : '')
          i++
        }
        return str
      } else {
        return '--'
      }
    })
    Vue.filter('TO_SHORT_DATE', (v) => {
      if (v) {
        var options = { month: 'short', day: '2-digit' }
        let date = new Date(v)
        return date.toLocaleDateString('pt-BR', options).split(' de ').reverse()
      } else {
        return '--'
      }
    })
    Vue.filter('TO_DATE_TIME', (v) => {
      if (v) {
        let date = new Date(v)
        return date.toLocaleDateString('pt-BR', { day: 'numeric', month: 'numeric', year: 'numeric' }) + ' às ' + date.getHours() + ':' + (date.getMinutes() < 10 ? '0' : '') + date.getMinutes('MM')
      } else {
        return '--'
      }
    })
    Vue.filter('APPOINTMENT_TYPE', (v) => {
      if (v) {
        const APPOINTMENT_TYPE = {
          'DRCONECTA': 'Dr. Conecta',
          'DRCONECTA_TELEMEDICINA': 'Dr. Conecta Telemedicina',
          'PARTICULAR': 'Particular',
          'PARTICULAR_TELEMEDICINA': 'Particular Telemedicina',
          'CONVENIO': 'Convênio'
        }
        return APPOINTMENT_TYPE[v]
      }
      return '--'
    })
    Vue.filter('TO_TIME', (v) => {
      if (v) {
        let date = new Date(v)
        return date.toLocaleTimeString('pt-BR')
      } else {
        return '--'
      }
    })
    Vue.filter('TO_HOUR_MINUTE', (v) => {
      if (v) {
        let date = new Date(v)
        return date.toLocaleTimeString('pt-BR', {hour: '2-digit', minute: '2-digit'})
      } else {
        return '--'
      }
    })
    Vue.filter('ADD_IMG_PATH', (v) => {
      return this.API_URL
    })

    Vue.filter('TO_SHORT_NAME', (v) => {
      if (v) {
        // const nomes = v.match(/(\S+)/g)
        const nomes = v.split(' ')
        return nomes[0] + ' ' + (nomes.length > 1 ? nomes[nomes.length - 1] : '')
        // const n = nomes.filter(word => word !== 'da' && word !== 'das' && word !== 'de' && word !== 'di' && word !== 'do' && word !== 'dos')
        // return (n[0].length <= 11 && n[1].length <= 11)
        //   ? `${n[0]} ${n[1]}`
        //   : `${n[0]}`
      }
    })

    Vue.filter('REMOVE_UNDERSCORE', (v) => {
      return String(v).replace('_', ' ')
    })

    Vue.filter('TO_LOWER_CASE', (value) => {
      return `${(String(value)).charAt(0).toUpperCase()}${(String(value).toLowerCase()).slice(1)}`
    })

    Vue.filter('TO_ALL_LOWER', value => String(value).toLowerCase())

    Vue.filter('TO_CAPITALIZE', (value) => {
      // não aplica capitalize em strings que sejam endereços de e-mail
      if (/[@]/gi.test(value)) {
        return value.toLowerCase()
      }

      const words = String(value)
        .toLowerCase()
        .split(/[ ,+]/gmi)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))

      return words.join(' ')
    })
  }
}
export default GlobalFilters
